/* global axios */
import ApiClient from '../ApiClient';

// Estado/vinculación de un inbox de WhatsApp por QR (admin-only). Backend: Api::V1::Accounts::Masifi::WhatsappQrController.
class MasifiWhatsappQrAPI extends ApiClient {
  constructor() {
    super('masifi/whatsapp_qr', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}`);
  }

  connect(inboxId, { riskAccepted = false } = {}) {
    return axios.post(`${this.url}/${inboxId}/connect`, {
      risk_accepted: riskAccepted,
    });
  }

  pause(inboxId) {
    return axios.post(`${this.url}/${inboxId}/pause`);
  }

  unlink(inboxId) {
    return axios.post(`${this.url}/${inboxId}/unlink`);
  }

  // Ajustes por número (F2 ruling 13): solo las claves presentes; el backend hace merge atómico en provider_config.
  // + `groups` = "Recibir grupos" (F3a).
  updateSettings(inboxId, { markAsRead, showReactions, groups } = {}) {
    const body = {
      mark_as_read: markAsRead,
      show_reactions: showReactions,
      groups,
    };
    Object.keys(body).forEach(key => {
      if (body[key] === undefined) delete body[key];
    });
    return axios.patch(`${this.url}/${inboxId}/settings`, body);
  }
}

// Estado grueso del número para los agentes del inbox (F2 ruling 15). Backend: WhatsappQrStatusController.
// Instancia de ApiClient (no una 2ª clase: max-classes-per-file) con `get(inboxId)` = show.
export const masifiWhatsappQrStatusAPI = Object.assign(
  new ApiClient('masifi/whatsapp_qr_status', { accountScoped: true }),
  {
    get(inboxId) {
      return axios.get(`${this.url}/${inboxId}`);
    },
  }
);

export default new MasifiWhatsappQrAPI();
